module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/fonts/basis_grotesque_regular-7a9ef7225f0b0f58f75de5a35b131c82.woff2";